import type { PaginationInformation } from '@sparklayer-io/spark-dash-ui/utils/pagination';
import type { ApiHandlerContract } from '../types/handlers/api';

/**
 * Generic API service class to be extended by specific service classes.
 */
export abstract class ApiService {
  constructor(protected api: ApiHandlerContract) {}
}

/**
 * A generic paginated response from a SparkLayer API.
 */
export type PaginatedResponse<T> = {
  data: T[];
  pagination: PaginationInformation;
};

export type { PaginationInformation } from '@sparklayer-io/spark-dash-ui/utils/pagination';
export type { ApiHandlerContract } from '../types/handlers/api';
